// Date/time helpers that never go through Date-with-timezone parsing for date-only values.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const isISODate = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s || "");

export function fmtMDY(s) {
  if (!isISODate(s)) return s || "";
  const [y, m, d] = s.split("-");
  return `${m}/${d}/${y}`;
}

export function fmtShortDate(s) {
  if (!isISODate(s)) return s || "";
  const [y, m, d] = s.split("-").map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
}

export function addDaysISO(s, n) {
  if (!isISODate(s)) return "";
  const [y, m, d] = s.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + n));
  return dt.toISOString().slice(0, 10);
}

export function to24(t) {
  const m = /^(\d{1,2}):(\d{2})\s*([AP])M$/i.exec((t || "").trim());
  if (!m) return "";
  let h = Number(m[1]) % 12;
  if (m[3].toUpperCase() === "P") h += 12;
  return `${String(h).padStart(2, "0")}:${m[2]}`;
}

export function to12(v) {
  if (!/^\d{2}:\d{2}$/.test(v || "")) return "";
  const [h, mi] = v.split(":").map(Number);
  return `${h % 12 || 12}:${String(mi).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
}

export function addMinutes(v24, mins) {
  if (!/^\d{2}:\d{2}$/.test(v24 || "") || !(mins > 0)) return "";
  const [h, m] = v24.split(":").map(Number);
  const t = (h * 60 + m + Number(mins)) % (24 * 60);
  return `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
}

export function diffMinutes(a24, b24) {
  if (!/^\d{2}:\d{2}$/.test(a24 || "") || !/^\d{2}:\d{2}$/.test(b24 || "")) return 0;
  const [ah, am] = a24.split(":").map(Number);
  const [bh, bm] = b24.split(":").map(Number);
  return bh * 60 + bm - (ah * 60 + am);
}
